module.exports = __webpack_public_path__ + "static/media/office.989d6231.png";